import {
    Box,
    Table,
    Typography,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    CircularProgress
} from "@mui/material";
import { useLocation } from "react-router-dom";
import React from "react";
import * as Action from "../../actions/adminAction"
import ImageUpload from "../../Components/ImageUpload";
import { connect } from "react-redux";

const borderSx = "2px solid";
const videoCategories = ['Teacher or Principal video', 'Training video', 'Test 1 video', 'Test 2 video']

export const FormFill = ({
    getCategories,
    GenerRateReport
}) => {
    const [isGeneratingReport, setIsGeneratingReport] = React.useState(false);
    const [studentPresentCount, setStudentPresentCount] = React.useState({
        ekunPat: "", // एकूण पट (total enrollment)
        vidyarthi: "", // उपस्थित विद्यार्थी (present boys)
        vidyarthini: "", // उपस्थित विद्यार्थिनी (present girls)
        ekunUpasthit: "", // एकूण उपस्थित (total present)
    });

    const [image, setImage] = React.useState(null);

    const [categorywiseImage, setCategorywiseImage] = React.useState([
        // {
        //     categoryName: 'प्रशिक्षण छार्ार्ित्रे',
        //     images: [],
        //     showUpload: true,
        // }
    ])
    const [selectedImages, setSelectedImages] = React.useState([]);

    const { state } = useLocation();
    const [sessionSubjectRows, setSessionSubjectRows] = React.useState(() => [
        {
            sessionType: "सैद्धांतिक",
            subject: state?.categoryType === "Theory" ? state?.trainingModuleName : "-",
            description: "",
        },
        {
            sessionType: "प्रात्यक्षिक",
            subject: state?.categoryType === "Practical" ? state?.trainingModuleName : "-",
            description: "",
        },
        { sessionType: "प्रक्षेत्र", subject: "", description: "" },
    ]);

    const getAllCategories = async () => {
        // setLoader(true)

        try {
            const result = await getCategories({
                "grampanchayat_id": state?.grampanchayat_id,
                "trainingModule_id": state?.trainingModule_id,
                "training_id": state?._id,
                "isReport": true,
            })

            if (result) {
                // console.log('result: ',result)
                const data = []
                result.forEach(obj => {
                    const catData = {
                        categoryName: obj?._id,
                        images: obj?.category?.map(oo => oo.documentUrl) ?? [],
                        showUpload: false
                    }

                    data.push(catData)
                })

                setCategorywiseImage(data)

            }
        } catch (error) {
            console.error("Failed to load categories:", error);
        } finally {
            // set loader to false
        }

        // if (result) {
        // console.log("Categories", result)
        // setcategories(result)
        // setLoader(false)
        // }
        // else {
        //     setLoader(false)
        // }
    }

    const handleGenerateReport =
        async () => {
            if (isGeneratingReport) return;
            setIsGeneratingReport(true);

            try {
                const beneficiaryData = {
                    "एकूण पट": studentPresentCount.ekunPat,
                    "उपस्थित विद्यार्थी": studentPresentCount.vidyarthi,
                    "उपस्थित विद्यार्थिनी": studentPresentCount.vidyarthini,
                    "एकूण उपस्थित": studentPresentCount.ekunUpasthit,

                    "शाळा": state?.grampanchayatName || "-",
                    "गाव": state?.grampanchayatName || "-",
                    "तालुका": state?.talukaName || "-",
                    "जिल्हा": state?.districtName || "-",
                    "प्रकल्प कार्यालय": state?.prakalpKaryalay,
                    "तारीख": state?.tarikh,
                    "प्रशिक्षक": state?.prashikshak,
                    "सैद्धांतिक": state?.categoryType === 'Theory' ? state?.trainingModuleName : '-',
                    "प्रात्यक्षिक": state?.categoryType === 'Practical' ? state?.trainingModuleName : '-',
                    "प्रक्षेत्र": '-',
                    "तपशील": sessionSubjectRows.map(({ sessionType, subject, description }) => ({
                        sessionType,
                        subject,
                        description,
                    })),
                    categoryType: state?.categoryType
                }


                const imageData = categorywiseImage.reduce((selectedCategories, { categoryName, images }) => {
                    const selectedCategoryImages = images.filter((imageItem) =>
                        selectedImages.some((selectedImage) =>
                            selectedImage.categoryName === categoryName && selectedImage.image === imageItem
                        )
                    );

                    if (selectedCategoryImages.length) {
                        selectedCategories.push({
                            categoryName,
                            images: selectedCategoryImages,
                        });
                    }

                    return selectedCategories;
                }, []);

                const data = {
                    trainer_idAll: state?.trainer_idAll,
                    trainerNameAll: state?.trainerNameAll,
                    trainerMobileAll: state?.trainerMobileAll,
                    trainerSignature: state?.trainerSignature,
                    trainerCount: state?.trainerCount,
                    docUploadedCount: state?.docUploadedCount,
                    docApprovedCount: state?.docApprovedCount,
                    typeOfDoc: state?.typeOfDoc,
                    typeOfDocStatus: state?.typeOfDocStatus,
                    isAssigned: state?.isAssigned,
                    isApprovedFinal: state?.isApprovedFinal,
                    isRejectedFinal: state?.isRejectedFinal,
                    totalBeneficiaryData: state?.totalBeneficiaryData,
                    castBifircation: state?.castBifircation,
                    representative: state?.representative,
                    feedbackformData: state?.feedbackformData,
                    resultform: state?.resultform,
                    status: state?.status,
                    isDelete: state?.isDelete,
                    _id: state?._id,
                    trainer_id: state?.trainer_id,
                    trainerName: state?.trainerName,
                    trainingModule_id: state?.trainingModule_id,
                    trainingModuleName: state?.trainingModuleName,
                    distric_id: state?.distric_id,
                    districtName: state?.districtName,
                    taluka_id: state?.taluka_id,
                    talukaName: state?.talukaName,
                    grampanchayat_id: state?.grampanchayat_id,
                    grampanchayatName: state?.grampanchayatName,
                    createdBy: state?.createdBy,
                    createdAt: state?.createdAt,
                    updatedAt: state?.updatedAt,
                    endDate: state?.endDate,
                    shift: state?.shift,
                    startDate: state?.startDate,
                    updatedBy: state?.updatedBy,
                    beneficiaryData,
                    imageData
                }

                const res = await GenerRateReport(data);
                const pdfUrl = typeof res === "string" ? res : res?.pdfUrl;

                if (!pdfUrl) {
                    throw new Error(res?.message || "Report generation did not return a PDF URL.");
                }

                const link = document.createElement("a");
                link.href = pdfUrl;
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                document.body.appendChild(link);
                link.click();
                link.remove();
            } catch (error) {
                console.error("Failed to generate or download report:", error);
            } finally {
                setIsGeneratingReport(false);
            }

        }



    React.useEffect(() => {
        getAllCategories()
    }, [])

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: { xs: 2, sm: 2.5 },
                minHeight: "100vh",
                width: "100%",
                minWidth: 0,
                overflowX: "hidden",
                paddingBottom: { xs: 3, sm: 4 },
                boxSizing: "border-box",
            }}
        >
            <Typography
                sx={{
                    width: "100%",
                    margin: { xs: "12px 0 4px", sm: "20px 0 8px" },
                    fontSize: { xs: 24, sm: 32, md: 40 },
                    fontWeight: 700,
                    textAlign: "center",
                }}
            >
                प्रशिक्षण अहवाल
            </Typography>

            <TrainingFormHeader
                values={{
                    shaala: state?.grampanchayatName || "-",
                    gaon: state?.grampanchayatName || "-",
                    taluka: state?.talukaName || "-",
                    jilha: state?.districtName || "-",
                    prakalpKaryalay: "प्रकल्प कार्यालय 1",
                    tarikh: state?.fromDate ? state.fromDate.split('T')[0] : "-",
                    prashikshak: state?.trainerName || "-"
                }}
                editable={true}
                onChange={(field, val) => console.log(field, val)}
            />

            <SessionSubjectDetails
                rows={sessionSubjectRows}
                onDescriptionChange={(rowIndex, description) =>
                    setSessionSubjectRows((rows) =>
                        rows.map((row, index) =>
                            index === rowIndex ? { ...row, description } : row
                        )
                    )
                }
            />

            <StudentAttendanceCount
                values={studentPresentCount}
                onChange={(field, val) => setStudentPresentCount((prev) => ({ ...prev, [field]: val }))}
            />


            <Box
                sx={{
                    width: "100%",
                    maxWidth: 1024,
                    display: 'flex',
                    boxSizing: "border-box",
                    flexDirection: 'column',
                    border: '2px solid',
                    borderRadius: 2,
                    padding: { xs: 1, sm: 2.5 },
                    gap: { xs: 1.5, sm: 2.5 },
                    minWidth: 0,
                }}
            >


                {
                    categorywiseImage.filter((item => !videoCategories.includes(item.categoryName))).map(({ images, showUpload, categoryName }, index) => (

                        <Box
                            key={categoryName}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                border: '2px solid',
                                borderRadius: 2,
                                gap: { xs: 1.5, sm: 2.5 },
                                padding: { xs: 1, sm: 2.5 },
                                minWidth: 0,
                            }}
                        >
                            <Typography
                                sx={{
                                    margin: { xs: "4px 0", sm: "8px 12px" },
                                    fontSize: { xs: 18, sm: 20 },
                                    fontWeight: 600,
                                    overflowWrap: "anywhere",
                                }}
                            >
                                {categoryName}
                            </Typography>

                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flexWrap: "wrap",
                                    alignItems: "flex-start",
                                    gap: { xs: 1, sm: 2.5 },
                                    minWidth: 0,
                                }}
                            >
                                {
                                    images.map((img, index2) => {
                                        const isSelected = selectedImages.some((selectedImage) =>
                                            selectedImage.categoryName === categoryName && selectedImage.image === img
                                        );

                                        return (
                                            <Box
                                                key={`${categoryName}-${img?.name || index2}`}
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    width: { xs: "100%", sm: "auto" },
                                                    maxWidth: "100%",
                                                    "& img": {
                                                        maxWidth: "100%",
                                                        height: "auto",
                                                    },
                                                }}
                                            >
                                                <ImageUpload
                                                    value={img}
                                                    maxSizeMB={5}
                                                    onChange={(newImage) => {
                                                        if (newImage === null) {
                                                            const updatedList = images.filter((_, imageIndex) => imageIndex !== index2);

                                                            setSelectedImages(prev => prev.filter((selectedImage) =>
                                                                selectedImage.categoryName !== categoryName || selectedImage.image !== img
                                                            ));
                                                            setCategorywiseImage(prev => prev.map((item) =>
                                                                item.categoryName === categoryName
                                                                    ? { ...item, images: updatedList, showUpload: !updatedList.length }
                                                                    : item
                                                            ));
                                                        }
                                                    }}
                                                />
                                                <FormControlLabel
                                                    control={(
                                                        <Checkbox
                                                            checked={isSelected}
                                                            onChange={() => setSelectedImages(prev => (
                                                                isSelected
                                                                    ? prev.filter((selectedImage) =>
                                                                        selectedImage.categoryName !== categoryName || selectedImage.image !== img
                                                                    )
                                                                    : [...prev, { categoryName, image: img }]
                                                            ))}
                                                        />
                                                    )}
                                                    label="Choose"
                                                />
                                            </Box>
                                        );
                                    })
                                }

                                {
                                    showUpload && images.length < 3 && (
                                        <ImageUpload
                                            value={image}
                                            onChange={(newImage) => {
                                                if (newImage) {

                                                    setCategorywiseImage(prev => (
                                                        prev.map((item, idx) => {
                                                            if (item.categoryName === categoryName) {
                                                                return {
                                                                    ...item,
                                                                    images: [...item.images, newImage],
                                                                    showUpload: false,
                                                                };
                                                            }

                                                            return item;
                                                        })
                                                    ))

                                                }
                                            }}
                                            maxSizeMB={5}
                                        />
                                    )
                                }

                                {/*  Button control functionality */}
                                {/* {
                                        images.length > 0 && images.length < 3 && (
                                            <button
                                                style={{
                                                    width: 50,
                                                    height: 50,
                                                    borderRadius: 5,
                                                    border: '2px solid #bdbdbd',
                                                    backgroundColor: '#f5f5f5',
                                                    fontSize: 24,
                                                    fontWeight: 700,
                                                    color: '#757575',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}
                                                onClick={() => setCategorywiseImage(prev => (
                                                    prev.map(item => {
                                                        if (item.categoryName === categoryName) {
                                                            return {
                                                                ...item,
                                                                showUpload: !item.showUpload,
                                                            };
                                                        }

                                                        return item;
                                                    })
                                                ))}
                                            >
                                                {showUpload ? '-' : '+'}
                                            </button>
                                        )
                                    } */}
                            </Box>

                        </Box>
                    ))
                }

            </Box>

            <Typography
                sx={{
                    width: "100%",
                    maxWidth: 1024,
                    fontWeight: 700,
                    textAlign: "left",
                }}
            >
                प्रशिक्षकांची स्वाक्षरी - {state?.trainerName || "-"}
            </Typography>

            <Button
                variant="contained"
                onClick={handleGenerateReport}
                disabled={isGeneratingReport}
                startIcon={isGeneratingReport ? <CircularProgress size={18} color="inherit" /> : null}
                sx={{
                    backgroundColor: "#1d5a96",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: 600,
                    padding: "10px 24px",
                    borderRadius: "6px",

                    "&:hover": {
                        backgroundColor: "#154675",
                    },
                }}
            >
                {isGeneratingReport ? "Generating..." : "Generate"}
            </Button>


        </Box>
    )
}


/**
 * TrainingFormHeader
 *
 * Props:
 *  - values: { shaala, gaon, taluka, jilha, prakalpKaryalay, tarikh, prashikshak }
 *      Default values, typically passed in via route/navigation state
 *      from the parent screen (already filled).
 *  - editable: boolean
 *      Global switch. false (default) => every field renders read-only.
 *      true  => every field renders as an editable TextField.
 *  - editableFields: string[]
 *      Optional finer-grained control. If provided, only the field
 *      names listed here become editable, regardless of `editable`.
 *      e.g. editableFields={['tarikh']} makes only the Date field editable.
 *  - onChange: (fieldName, newValue) => void
 *      Fired when an editable field changes. Only relevant when at
 *      least one field is editable.
 */
const TrainingFormHeader = ({
    values = {},
    editable = false,
    editableFields = null,
    onChange = null,
}) => {
    const isFieldEditable = (fieldName) => {
        if (editableFields && editableFields.length > 0) {
            return editableFields.includes(fieldName);
        }
        return editable;
    };

    return (
        <Box
            sx={{
                border: borderSx,
                borderRight: "0px",
                borderColor: "text.primary",
                width: "100%",
                maxWidth: 1024,
                minWidth: 0,
                fontFamily:
                    '"Noto Sans Devanagari", "Mangal", Arial, sans-serif',
            }}
        >
            {/* Row 1: शाळा (spans full width) */}
            <FormRow>
                <FormCell
                    label="शाळा"
                    name="shaala"
                    value={values.shaala}
                    editable={isFieldEditable("shaala")}
                    onChange={onChange}
                />
            </FormRow>

            {/* Row 2: गाव | तालुका */}
            <FormRow>
                <FormCell
                    label="गाव"
                    name="gaon"
                    value={values.gaon}
                    editable={isFieldEditable("gaon")}
                    onChange={onChange}
                />
                <FormCell
                    label="तालुका"
                    name="taluka"
                    value={values.taluka}
                    editable={isFieldEditable("taluka")}
                    onChange={onChange}
                />
            </FormRow>

            {/* Row 3: जिल्हा | प्रकल्प कार्यालय */}
            <FormRow>
                <FormCell
                    label="जिल्हा"
                    name="jilha"
                    value={values.jilha}
                    editable={isFieldEditable("jilha")}
                    onChange={onChange}
                    labelWidth={110}
                />
                <FormCell
                    label="प्रकल्प कार्यालय"
                    name="prakalpKaryalay"
                    value={values.prakalpKaryalay}
                    editable={isFieldEditable("prakalpKaryalay")}
                    onChange={onChange}
                    labelWidth={150}
                />
            </FormRow>

            {/* Row 4: तारीख | प्रशिक्षक */}
            <FormRow isLast>
                <FormCell
                    label="तारीख"
                    name="tarikh"
                    value={values.tarikh}
                    editable={isFieldEditable("tarikh")}
                    onChange={onChange}
                />
                <FormCell
                    label="प्रशिक्षक"
                    name="prashikshak"
                    value={values.prashikshak}
                    editable={isFieldEditable("prashikshak")}
                    onChange={onChange}
                    labelWidth={150}
                />
            </FormRow>
        </Box>
    );
};


/**
 * ------------------------------------------------------------------
 * Example usage (parent route passing default values via navigation):
 *
 *   import { useLocation } from "react-router-dom"; // ^6.0.2, per package.json
 *   import TrainingFormHeader from "./TrainingFormHeader";
 *
 *   const ParentPage = () => {
 *     const location = useLocation();
 *     // e.g. navigate("/training-form", { state: { shaala: "...", ... } })
 *     const incomingValues = location.state || {};
 *
 *     return (
 *       <TrainingFormHeader
 *         values={incomingValues}
 *         editable={false}          // read-only by default
 *         // editableFields={["tarikh"]}  // or open up just one field
 *         // onChange={(field, val) => console.log(field, val)}
 *       />
 *     );
 *   };
 * ------------------------------------------------------------------
 */



// ---- Cell wrapper -------------------------------------------------
// Renders a label cell + a value cell, side by side, matching the
// bordered-table look of the reference image.
const FormCell = ({
    label,
    name,
    value = "",
    onChange = null,
    editable = false,
    labelWidth = 110,
}) => {
    const handleChange = (e) => {
        if (onChange) onChange(name, e.target.value);
    };

    return (
        <Box className="form-cell" sx={{ display: "flex", flex: 1, minWidth: 0 }}>
            {/* Label */}
            <Box
                sx={{
                    width: { xs: Math.min(labelWidth, 120), md: labelWidth },
                    maxWidth: { xs: "45%", md: "none" },
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    px: { xs: 1, sm: 1.5 },
                    py: 1,
                    fontWeight: 700,
                    fontSize: { xs: "0.8rem", sm: "0.95rem" },
                    borderRight: borderSx,
                    borderColor: "text.primary",
                    overflowWrap: "anywhere",
                }}
            >
                {label}
            </Box>

            {/* Value */}
            <Box
                sx={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    px: { xs: 1, sm: 1.5 },
                    py: 0.5,
                    minWidth: 0,
                    borderRight: borderSx,
                    borderColor: "text.primary",
                }}
            >
                <TextField
                    name={name}
                    value={value ?? ""}
                    onChange={handleChange}
                    variant="standard"
                    fullWidth
                    InputProps={{
                        readOnly: !editable,
                        disableUnderline: true,
                    }}
                    sx={{
                        "& .MuiInputBase-input": {
                            fontSize: "0.95rem",
                            cursor: editable ? "text" : "default",
                            padding: "4px 0",
                        },
                    }}
                />
            </Box>
        </Box>
    );
};

// ---- Row wrapper (adds the horizontal divider between rows) -------
const FormRow = ({ children, isLast = false }) => (
    <Box
        sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            borderBottom: isLast ? "none" : borderSx,
            borderColor: "text.primary",
            "& > .form-cell + .form-cell": {
                borderTop: { xs: borderSx, md: "none" },
            },
        }}
    >
        {children}
    </Box>
);



const DEVANAGARI_DIGITS = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];
const toDevanagariNumeral = (num) =>
    String(num)
        .split("")
        .map((d) => DEVANAGARI_DIGITS[Number(d)] ?? d)
        .join("");

// ---- Default rows, matching the reference image --------------------
const DEFAULT_ROWS = [
    { sessionType: "सैद्धांतिक", subject: "", description: "" },
    { sessionType: "प्रात्यक्षिक", subject: "", description: "" },
    { sessionType: "प्रक्षेत्र", subject: "", description: "" },
];

const cellBorderSx = {
    border: borderSx,
    borderColor: "text.primary",
};

const SessionSubjectDetails = ({
    rows = DEFAULT_ROWS,
    title = "सत्र विषय तपशील",
    editable = false,
    minRowHeight = 90,
    onChange = null,
    onDescriptionChange = null,
}) => {
    const handleSubjectChange = (rowIndex, newValue) => {
        if (onChange) onChange(rowIndex, newValue);
    };

    return (
        <TableContainer
            sx={{
                width: "100%",
                maxWidth: 1024,
                overflowX: "auto",
                fontFamily: '"Noto Sans Devanagari", "Mangal", Arial, sans-serif',
            }}
        >
            <Table
                sx={{
                    minWidth: { xs: 720, md: "100%" },
                    borderCollapse: "collapse",
                    border: borderSx,
                }}
            >
                <TableHead>
                    {/* Title row, spanning all columns */}
                    <TableRow>
                        <TableCell
                            colSpan={4}
                            align="center"
                            sx={{
                                ...cellBorderSx,
                                fontWeight: 700,
                                fontSize: "1rem",
                                borderBottom: borderSx
                            }}
                        >
                            {title}
                        </TableCell>
                    </TableRow>

                    {/* Column header row */}
                    <TableRow>
                        <TableCell
                            align="center"
                            sx={{ ...cellBorderSx, fontWeight: 700, width: 90 }}
                        >
                            सत्र क्र.
                        </TableCell>
                        <TableCell
                            align="center"
                            sx={{ ...cellBorderSx, fontWeight: 700, width: 160 }}
                        >
                            सत्र स्वरूप
                        </TableCell>
                        <TableCell align="center" sx={{ ...cellBorderSx, fontWeight: 700 }}>
                            विषय
                        </TableCell>
                        <TableCell align="center" sx={{ ...cellBorderSx, fontWeight: 700 }}>
                            वर्णन
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {rows.map((row, index) => (
                        <TableRow key={index}>
                            {/* सत्र क्र. — auto-numbered, Devanagari numerals */}
                            <TableCell
                                align="center"
                                sx={{
                                    ...cellBorderSx,
                                    verticalAlign: "middle",
                                    height: minRowHeight,
                                }}
                            >
                                {toDevanagariNumeral(index + 1)}
                            </TableCell>

                            {/* सत्र स्वरूप */}
                            <TableCell
                                align="center"
                                sx={{
                                    ...cellBorderSx,
                                    verticalAlign: "middle",
                                }}
                            >
                                {row.sessionType}
                            </TableCell>

                            {/* विषय — editable or read-only, tall to allow writing */}
                            <TableCell
                                sx={{
                                    ...cellBorderSx,
                                    verticalAlign: "top",
                                    p: editable ? 0.5 : 1.5,
                                }}
                            >
                                {editable ? (
                                    <TextField
                                        value={row.subject ?? ""}
                                        onChange={(e) => handleSubjectChange(index, e.target.value)}
                                        variant="standard"
                                        fullWidth
                                        multiline
                                        minRows={3}
                                        InputProps={{ disableUnderline: true }}
                                        sx={{
                                            "& .MuiInputBase-input": { fontSize: "0.95rem" },
                                        }}
                                    />
                                ) : (
                                    <Box
                                        sx={{
                                            minHeight: minRowHeight - 24,
                                            whiteSpace: "pre-wrap",
                                            fontSize: "0.95rem",
                                        }}
                                    >
                                        {row.subject || ""}
                                    </Box>
                                )}
                            </TableCell>

                            {/* Description */}
                            <TableCell
                                sx={{
                                    ...cellBorderSx,
                                    verticalAlign: "top",
                                    p: 0.5,
                                }}
                            >
                                <TextField
                                    value={row.description ?? ""}
                                    onChange={(e) =>
                                        onDescriptionChange?.(index, e.target.value)
                                    }
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    minRows={3}
                                    inputProps={{ "aria-label": `Description for ${row.sessionType}` }}
                                    sx={{
                                        "& .MuiInputBase-input": { fontSize: "0.95rem" },
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};




let DEFAULT_VALUES = {
    ekunPat: "", // एकूण पट (total enrollment)
    vidyarthi: "", // उपस्थित विद्यार्थी (present boys)
    vidyarthini: "", // उपस्थित विद्यार्थिनी (present girls)
    ekunUpasthit: "", // एकूण उपस्थित (total present)
};

const StudentAttendanceCount = ({
    values = DEFAULT_VALUES,
    title = "उपस्थित विद्यार्थी संख्या",
    editable = true,
    autoCalculateTotal = true,
    onChange = null,
}) => {
    const emitChange = (fieldName, newValue) => {
        if (onChange) onChange(fieldName, newValue);
    };


    const handleFieldChange = (fieldName) => (e) => {
        const newValue = e.target.value;

        // Allow only numbers
        if (!/^\d*$/.test(newValue)) {
            return;
        }

        const ekunPat = fieldName === "ekunPat" ? newValue : values.ekunPat;
        const vidyarthi = fieldName === "vidyarthi" ? newValue : values.vidyarthi;
        const vidyarthini = fieldName === "vidyarthini" ? newValue : values.vidyarthini;
        const presentCount = (Number(vidyarthi) || 0) + (Number(vidyarthini) || 0);

        if (ekunPat !== "" && presentCount > Number(ekunPat)) {
            return;
        }

        emitChange(fieldName, newValue);

        if (autoCalculateTotal && ["ekunPat", "vidyarthi", "vidyarthini"].includes(fieldName)) {
            const numVidyarthi = Number(vidyarthi) || 0;
            const numVidyarthini = Number(vidyarthini) || 0;
            const total = vidyarthi === "" && vidyarthini === ""
                ? ""
                : numVidyarthi + numVidyarthini;
            emitChange("ekunUpasthit", total);
        }
    };

    const columns = [
        { key: "ekunPat", label: "एकूण पट" },
        { key: "vidyarthi", label: "उपस्थित विद्यार्थी" },
        { key: "vidyarthini", label: "उपस्थित विद्यार्थिनी" },
        { key: "ekunUpasthit", label: "एकूण उपस्थित" },
    ];

    return (
        <TableContainer
            sx={{
                width: "100%",
                maxWidth: 1024,
                overflowX: "auto",
                fontFamily: '"Noto Sans Devanagari", "Mangal", Arial, sans-serif',
            }}
        >
            <Table sx={{ minWidth: { xs: 560, md: "100%" }, borderCollapse: "collapse" }}>
                <TableHead>
                    {/* Title row, spanning all columns */}
                    <TableRow>
                        <TableCell
                            colSpan={columns.length}
                            align="center"
                            sx={{ ...cellBorderSx, fontWeight: 700, fontSize: "1rem" }}
                        >
                            {title}
                        </TableCell>
                    </TableRow>

                    {/* Column header row */}
                    <TableRow>
                        {columns.map((col) => (
                            <TableCell
                                key={col.key}
                                align="center"
                                sx={{ ...cellBorderSx, fontWeight: 700 }}
                            >
                                {col.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow>
                        {columns.map((col) => {
                            const isTotalField = col.key === "ekunUpasthit";
                            // const isTotalField = false;
                            const fieldIsEditable =
                                editable && !(isTotalField && autoCalculateTotal);

                            return (
                                <TableCell
                                    key={col.key}
                                    align="center"
                                    sx={{ ...cellBorderSx, height: 56, p: 1 }}
                                >
                                    {fieldIsEditable ? (
                                        <TextField
                                            value={values[col.key] ?? ""}
                                            onChange={handleFieldChange(col.key)}
                                            variant="outlined"
                                            size="small"
                                            type="text"
                                            placeholder="संख्या"
                                            aria-label={`${col.label} संख्या`}
                                            inputProps={{
                                                inputMode: "numeric",
                                                min: 0,
                                                style: { textAlign: "center" },
                                            }}
                                            fullWidth
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    backgroundColor: "#f8fafc",
                                                    "& fieldset": { borderColor: "#94a3b8" },
                                                    "&:hover fieldset": { borderColor: "#475569" },
                                                    "&.Mui-focused fieldset": { borderColor: "primary.main" },
                                                },
                                                "& .MuiInputBase-input": {
                                                    fontSize: "0.95rem",
                                                    textAlign: "center",
                                                },
                                            }}
                                        />
                                    ) : (
                                        <span style={{ fontSize: "0.95rem" }}>
                                            {values[col.key] ?? ""}
                                        </span>
                                    )}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};


const mapDispatchToProps = dispatch => {
    return {
        GenerRateReport: (data) => dispatch(Action.GenerRateReport(data)),
        getCategories: (data) => dispatch(Action.getCategories(data)),
    }
}

export default connect(null, mapDispatchToProps)(FormFill)